import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchAllContent, fetchCharters } from "./api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [charters, setCharters] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const [c, ch] = await Promise.all([fetchAllContent(), fetchCharters()]);
      setContent(c);
      setCharters(ch);
    } catch (e) {
      console.error("Failed to load site content", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SiteContext.Provider value={{ content, charters, loading, reload: load }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
};
